import { useListHoldReasonCodes } from '../hooks/useHoldDecisionActions';

interface HoldReasonSelectProps {
  value: string | null;
  onChange: (reasonCodeId: string) => void;
  disabled?: boolean;
  required?: boolean;
}

/**
 * AM-015 Rule HLD-02. Reasons come from the HoldReasonCode master-data
 * table, not a hardcoded list — a new reason (e.g. "برق قطع شد") can be
 * added by an admin from the settings page without a code deploy.
 */
export function HoldReasonSelect({ value, onChange, disabled, required = true }: HoldReasonSelectProps) {
  const { data: reasons, isLoading, isError } = useListHoldReasonCodes(true);

  if (isError) {
    return <p className="text-sm text-red-600">خطا در بارگذاری دلایل توقف.</p>;
  }

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="hold-reason-select" className="text-sm font-medium text-gray-700">
        دلیل توقف {required && <span className="text-red-500">*</span>}
      </label>
      <select
        id="hold-reason-select"
        className="rounded-md border border-gray-300 px-3 py-2 text-sm disabled:bg-gray-100"
        value={value ?? ''}
        disabled={disabled || isLoading}
        required={required}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="" disabled>
          {isLoading ? 'در حال بارگذاری…' : 'یک دلیل انتخاب کنید'}
        </option>
        {reasons?.map((reason) => (
          <option key={reason.id} value={reason.id}>
            {reason.description}
          </option>
        ))}
      </select>
    </div>
  );
}
